import { Checkbox, TableCell } from '@mui/material';
import type { TableColumnComponent } from 'app/common/components/table/types';
import { PureComponent } from 'react';
import type { toggleSelection } from '../../actions';

function stopPropagation(e: { stopPropagation: () => void }): void {
  e.stopPropagation();
}

export type SelectCellProps = {
  readonly toggleSelection: ReturnType<typeof toggleSelection>;
} & Pick<TableColumnComponent, 'value' | 'row' | 'tableName' | 'idFieldName' | 'disabledFieldName'>;

export default class SelectCell extends PureComponent<SelectCellProps> {
  public handleChange = (): void => {
    const { row, idFieldName, toggleSelection } = this.props;
    const id = idFieldName ? row[idFieldName] : row.id;
    toggleSelection(id);
  };

  public override render(): JSX.Element {
    const { value, row, disabledFieldName } = this.props;
    const disabled = disabledFieldName ? row[disabledFieldName] : false;
    return (
      <TableCell onClick={stopPropagation} padding="checkbox">
        <Checkbox checked={value} onChange={this.handleChange} disabled={disabled} color="primary" />
      </TableCell>
    );
  }
}
